<script lang="ts">
    import {getLocalization} from 'src/core';
    import type {CssSize} from 'shared/ui-widgets/types';

    export let width: CssSize = '250px';

    const localize = getLocalization();
</script>

<div class="kp-line-loading-indicator"
     style:width={width}
     role="progressbar"
     aria-label={localize(/* @kp-localization commons.LoadingInProgress */ 'commons.LoadingInProgress')}>

    <div role="presentation" class="inner-indicator"></div>
</div>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .kp-line-loading-indicator {
        position: relative;
        max-width: 90dvw;
        height: 8px;
        border-radius: 4px;
        overflow: hidden;
        background-color: @panel-default-border;

        .inner-indicator {
            position: absolute;
            left: 0;
            top: 0;
            width: 50%;
            height: 8px;
            background-color: var(--accent-blue);
            border-radius: 4px;
            animation: loading 2.5s infinite ease-in-out;
        }
    }

    @keyframes loading {
        0% {
            width: 50%;
            left: -50%;
        }
        100% {
            width: 25%;
            left: 100%;
        }
    }
</style>